import { auditReports } from '@mi-front/api-clients';
import { ViewLoader } from '@mi-front/ui';
import { AodRuleWizard } from '../aod-rules-add/AodRuleWizard';
import { useAodFactory } from '../aod-rules-add/custom/AodFactory';

interface AodRuleEditWizardProps {
  rule: auditReports.AodRule;
}

export function AodRuleEditWizard({ rule }: AodRuleEditWizardProps) {
  const values = useAodFactory(rule.reportType).apiToValues(rule);

  if (!values) {
    return <ViewLoader />;
  }

  return <AodRuleWizard initialData={values} />;
}
